/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InteractionType {
  QUESTION = "QUESTION",
  NEXT_PAGE = "NEXT_PAGE",
  HELP_ME = "HELP_ME",
  PREV_PAGE = "PREV_PAGE",
}
